<template>
  <div class="all">
    <div class="header">
      <div class="header_wrap">
        <img src="../assets/quickfix/logo.png" alt>
        <span>Quick</span>
        <span>
          Fix.
          <span style="font-size:18px">工具中心</span>
        </span>
      </div>
    </div>
    <div class="main">
      <div class="search">
        <div class="input">
          <el-input placeholder="工具搜索" v-model="value.name" prefix-icon="el-icon-search"></el-input>
        </div>

        <el-button type="primary" @click="getdata" style="width:70px;margin-left:5px">搜索</el-button>
        <el-button style="width:70px;margin-left:80px" @click="reset('')">重置</el-button>
        <el-button type="primary" style="width:150px;float:right" @click="toneeds">提交工具需求</el-button>
      </div>
      <div class="content">
        <div class="c_header">
          <el-button
            :type="type==true?'primary':'text'"
            size="mini"
            style="margin-right:20px"
            @click="reset(1)"
          >最近发布</el-button>
          <el-button
            :type="type==false?'primary':'text'"
            size="mini"
            style="margin-right:20px"
            @click="reset(2)"
          >最近更新</el-button>
        </div>
        <div class="c_main">
          <a
            :href="item.toolurl"
            target="_block"
            class="card"
            v-for="(item,index) in dataset"
            :key="index"
          >
            <div class="card_title">
              {{item.name|titlelimit}}
              <span>{{item.versions|vlimit}}</span>
            </div>
            <div class="card_main">
              <p>工具描述：</p>
              <p style="text-indent:2em;">{{item.description|decriplimit}}</p>
            </div>
            <div class="card_footer">最近更新时间：{{item.datetime|fotmatetime}}</div>
          </a>
        </div>
        <div class="c_footer">
          <el-pagination
            style="float:right"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="value.page"
            :page-sizes="[9, 45, 90, 180, 450]"
            :page-size="value.pagesize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="count"
          ></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { indexindex } from "@/api/forout";
import f from "@/libs/util.time";
import axios from "axios";
export default {
  name: "index",
  data() {
    return {
      value: {
        page: 1,
        size: 9,
        name: "",
        sort: 0
      },
      count: 10,
      filename: __filename,
      dataset: null,
      type: true
    };
  },
  mounted() {
    this.getdata();
  },
  filters: {
    fotmatetime(value) {
      var value = Number(value) * 1000;
      return f.fromateTs(value);
    },
    titlelimit(value) {
      if (!value) {
        return "";
      }
      return value.length > 15 ? value.slice(0, 15) + "..." : value;
    },
    decriplimit(value) {
      if (!value) {
        return "";
      }
      return value.length > 60 ? value.slice(0, 60) + "..." : value;
    },
    vlimit(value) {
      if (!value) {
        return "";
      }
      return value.length > 6 ? value.slice(0, 10) : value;
    }
  },
  methods: {
    toneeds() {
      this.$router.push("/needs");
    },
    //配置使用方法----------------------------------------------------------
    handleSizeChange(val) {
      this.value.size = val;
      this.getdata();
    },
    handleCurrentChange(val) {
      this.value.page = val;
      this.getdata();
    },
    reset(data) {
      this.value = {
        page: 1,
        size: 9,
        name: "",
        sort: data
      };
      switch (data) {
        case 2:
          this.type = false;
          break;
        default:
          this.type = true;
      }
      this.getdata();
    },
    //-----------------------------------------------------------------------
    getdata() {
      indexindex(this.value).then(res => {
        if (res.data.code == 200) {
          this.dataset = res.data.data.list;
          this.value.page = Number(res.data.data.page);
          this.value.pagesize = Number(res.data.data.size);
          this.count = Number(res.data.data.count);
        } else {
          alert(res.data.message);
          this.dataset = [];
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.header {
  height: 120px;
  background: #4da7f8;
  box-shadow: 5px 0 25px 0 #ddd;
  color: #fff;
  text-align: center;
  line-height: 70px;
  padding-top: 30px;
  box-sizing: border-box;
  font-size: 38px;
  // font-weight: bold;
  margin: 0 -8px;
  .header_wrap {
    position: relative;
    width: 1160px;
    margin: 0 auto;
    img{
      position: absolute;
      left: 0;
    }
    > span {
      margin-left: 10px;
    }
  }
}
.all {
  background: #eff5fa;
  padding-bottom: 10px;
}
.main {
  width: 1160px;
  margin: 0 auto;
  .search {
    height: 100px;
    padding-top: 27px;
    box-sizing: border-box;
  }
}
.input {
  width: 760px;
  display: inline-block;
}
.content {
  background: #fff;
  padding-bottom: 40px;
  margin-bottom: 40px;
}
.c_header {
  text-align: right;
  height: 70px;
  border-bottom: 1px solid #eee;
  line-height: 70px;
}
.c_main {
  padding: 40px 40px 0;
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}
.card {
  width: 330px;
  height: 200px;
  border: 1px solid #bdd9ff;
  border-radius: 6px;
  margin-bottom: 40px;
  box-sizing: border-box;
  padding: 10px;
  position: relative;
  margin: 0 15px 40px;
  overflow: hidden;
  text-decoration: none;
}
.card_title {
  color: #0c6ff6;
  line-height: 40px;
  font-size: 18px;
  font-weight: 600;
  border-bottom: 1px solid #bdd9ff;
}
.card_main {
  font-size: 14px;
  line-height: 22px;
  color: #687485;
  text-align: left;
  word-wrap: break-word;
}
.card_main p {
  margin: 10px 0;
}
.card_footer {
  height: 30px;
  line-height: 30px;
  text-align: right;
  color: #a4acb7;
  font-size: 12px;
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 0 10px;
  box-sizing: border-box;
}
.card:hover {
  background: #0c6ff6;
  box-shadow: 0 0 20px 0 #c2dcff;
}
.card:hover .card_title,
.card:hover .card_main,
.card:hover .card_footer {
  color: #ffffff;
}
.c_footer {
  text-align: right;
  padding-top: 70px;
  padding: 0 40px;
  box-sizing: border-box;
}
</style>


// WEBPACK FOOTER //
// src/pages/index.vue